var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('surveys-grid',{attrs:{"items":_vm.quizzes,"page-title":_vm.pageTitle,"return-page":"quizzes","empty-text":"Brak quizów"},on:{"refresh":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }